const BlockActionRedirectionDefault = {
    name : "Redirection by keywords",
    action_type : { name : "keyword_redirection"},
    type : { name : 'action'},
    data : {
        redirections : [],
        variable : null,
        variable_redirect : null,
    },
    children : [
        {text: "Other", index : null, object_id : null, parent_block_id : null},
    ],
}

const BlockActionRedirectionServerDefault = {
    name : "Redirection by keywords",
    action_type : "keyword_redirection",
    redirections : [],
    //keyword_var : null,
    //keyword_redirect_var : null,
}

export {BlockActionRedirectionDefault, BlockActionRedirectionServerDefault}